import _ from 'lodash';
import getHistory from 'globalHistory';
import qs from 'querystring';

/**
 * @type {String}
 */
export const FLYOUT_URL_KEY = 'flyout';

/**
 * @type {String}
 */
export const FLYOUT_CONTENT_ID = 'flyout-content';

/**
 * @type {Object}
 */
export const FLYOUT_TYPES = {
  TASK_CREATE: 'task_create',
  TASK_EDIT: 'task_edit',
  TASK_REOPEN: 'task_reopen',
  TASK_PLANNING_EDIT: 'task_planning_edit',
  TASK_TIMING: 'task_timing',
  TASK_SERIES: 'task_series',
  TASK_ASSIGN: 'task_assign',

  TASK_BULK_CREATE: 'task_bulk_create',
  TASK_BULK_EXPORT: 'task_bulk_export',
  TASK_BULK_EXPORT_PARTNER: 'task_bulk_export_partner',
  TASK_BULK_ASSIGNMENT: 'task_bulk_assignment',
  TASK_BULK_SCHEDULE: 'task_bulk_schedule',
  TASK_BULK_PRIORITY: 'task_bulk_priority',
  TASK_BULK_COMMENT: 'task_bulk_comment',

  TASK_DRAFT_SCHEDULE: 'task_draft_schedule',
  TASK_DRAFT_PLANNING_EDIT: 'task_draft_planning_edit',

  TASK_WORKFLOW_EDIT: 'task_workflow_edit',

  PERSON_ACCOUNT_INVITE: 'person_account_invite',
  PEOPLE_BULK_EXPORT: 'people_bulk_export',

  PROPERTY_BULK_EXPORT: 'property_bulk_export',

  SUPPLY_UPLOAD: 'supply_upload',
  SUPPLY_FORM: 'supply_form',

  RESERVATION_DETAILS: 'reservation_details',

  DASHBOARD_FILTERS: 'dashboard_filters',
  DASHBOARD_MAP_FILTERS: 'dashboard_map_filters',
  ELEMENT_TASK_LIST_FILTERS: 'element_task_list_filters',
  OFFER_LIST_FILTERS: 'offer_list_filters',
  PROPERTY_LIST_FILTERS: 'property_list_filters',
  PROPERTY_TASK_LIST_FILTERS: 'property_task_list_filters',
  SCHEDULE_FILTERS: 'schedule_filters',
  TASK_LIST_FILTERS: 'task_list_filters',

  MESSENGER_CONTACT_DETAILS: 'messenger_contact_details',
};

/**
 * @type {Array}
 */
export const FLYOUT_TYPES_WITHOUT_STICKY_HEADER = [
  FLYOUT_TYPES.TASK_CREATE,
  FLYOUT_TYPES.TASK_BULK_CREATE,
];

/**
 * @param {Object} location
 * @return {String}
 */
export const getFlyoutFromLocation = location => {
  const flyoutParam = _.split(_.get(location, 'search'), FLYOUT_URL_KEY);
  const isFlyout = _.size(flyoutParam) === 2;

  if (!isFlyout) return null;

  return qs.parse(`flyout${_.last(flyoutParam)}`);
};

/**
 * @param {String} type
 * @param {Object} params
 */

export const removeFlyout = () => {
  const { location } = getHistory();
  const search = _.split(_.replace(_.get(location, 'search'), '?', ''), FLYOUT_URL_KEY);
  const urlWithoutFlyout = _.omit(qs.parse(_.first(search)), '');
  const newSearch = qs.stringify(urlWithoutFlyout);

  getHistory().push({
    ...location,
    search: newSearch,
  });
};

export const addFlyout = async (type, params) => {
  const { location } = getHistory();
  const search = _.split(_.replace(_.get(location, 'search'), '?', ''), FLYOUT_URL_KEY);
  const urlWithoutFlyout = _.omit(qs.parse(_.first(search)), '');
  const lastSearch = qs.stringify(urlWithoutFlyout);

  const flyoutString = qs.stringify({
    flyout: type,
    ...params,
  });

  const newSearch = !_.isEmpty(lastSearch) ? `${lastSearch}&${flyoutString}` : `?${flyoutString}`;

  const newLocation = {
    ...location,
    search: newSearch,
  };

  getHistory().push(newLocation);
};

/**
 * @param {Object} flyout
 * @return {Boolean}
 */
export const shouldHaveStickyHeader = flyout =>
  !_.includes(FLYOUT_TYPES_WITHOUT_STICKY_HEADER, _.get(flyout, FLYOUT_URL_KEY));

/**
 * @param {String} sectionId
 */
export const scrollFlyoutToSection = sectionId => {
  const flyoutContent = _.invoke(document, 'getElementById', FLYOUT_CONTENT_ID);
  const section = _.invoke(document, 'getElementById', sectionId);
  flyoutContent.scrollTop = _.get(section, 'offsetTop', 0);
};
